
import OpenTicketReportApi from '@/api/OpenTicketReportApi'
import { computed } from '@vue/reactivity';
import { getTodayNowTime, getTodayStartTime, getThisMonthStartTime, getThisWeekStartTime, getThisYearStartTime } from '@/utils/date.util'
import { defineComponent, onMounted, reactive, ref, onBeforeUnmount } from 'vue'

export default defineComponent({
  setup () {
    let timer = 0;
    const solvePercent = ref(0)
    const solveDurationData = reactive([
      {
        label: '新建工单数',
        value: '--'
      },
      {
        label: '未响应工单数',
        value: '--'
      },
      {
        label: '响应超时工单数',
        value: '--'
      },
      {
        label: '处理超时工单数',
        value: '--'
      }
    ])
    const timeRef = ref<string>('THIS_DAY')
    const timeMap = new Map([
      ['THIS_DAY', '今日'],
      ['THIS_WEEK', '本周'],
      ['THIS_MONTH', '本月'],
      ['THIS_YEAR', '本年']
    ])

    const timeFilter = computed(() => {
      return (value) => {
        return timeMap.get(value + '')
      }
    })

    function setTime (status: string) {
      timeRef.value = status
      timer && clearTimeout(timer)
      statisticsTicketMetrics()
    }

    function statisticsTicketMetrics () {
      let startDate: string | null = null
      const endDate: string | null = getTodayNowTime();
      if (timeRef.value === 'THIS_DAY') {
        startDate = getTodayStartTime()
      } else if (timeRef.value === 'THIS_WEEK') {
        startDate = getThisWeekStartTime()
      } else if (timeRef.value === 'THIS_MONTH') {
        startDate = getThisMonthStartTime()
      } else if (timeRef.value === 'THIS_YEAR') {
        startDate = getThisYearStartTime()
      }
      OpenTicketReportApi.statisticsTicketMetrics({
        startDate,
        endDate
      }).then(res => {
        solveDurationData[0].value = String(res.newTicketCount || 0);
        solveDurationData[1].value = String(res.unrespondedTicketCount || 0);
        solveDurationData[2].value = String(res.responseTimeoutTicketCount || 0);
        solveDurationData[3].value = String(res.handleTimeoutTicketCount || 0);
        solvePercent.value = parseFloat(((res.goodRate || 0) * 100).toFixed(2));
        timer = setTimeout(() => {
          statisticsTicketMetrics();
        }, 5000)
      })
    }

    onMounted(() => {
      statisticsTicketMetrics()
    })

    onBeforeUnmount(() => {
      clearTimeout(timer);
    })

    return {
      timeFilter,
      timeRef,
      setTime,
      solvePercent,
      solveDurationData
    }
  }
})
